import ViewAPIKeysContainer from 'js/components/apiKeys/ViewAPIKeysContainer';
import CredentialFormContainer from 'js/components/credentials/CredentialFormContainer';
import ViewCredentialsContainer from 'js/components/credentials/ViewCredentialsContainer';
import DataMapDashboardContainer from 'js/components/data_maps/DataMapDashboardContainer';
import DataMapsEditFormContainer from 'js/components/data_maps/DataMapsEditFormContainer';
import ViewDataSetsContainer from 'js/components/data_sets/ViewDataSetsContainer';
import ViewDataSinksContainer from 'js/components/data_sinks/ViewDataSinksContainer';
import AddDataSourceFormContainer from 'js/components/data_sources/AddDataSourceFormContainer';
import ViewDataSourcesContainer from 'js/components/data_sources/ViewDataSourcesContainer';
import DestinationSetupContainer from 'js/components/destination/DestinationSetupContainer';
import lazyRetry from 'js/components/lazyRetry';
import PipelineFormContainer from 'js/components/pipelines/PipelineFormContainer';
import PipelinesContainer from 'js/components/pipelines/PipelinesContainer';
import PipelinesByProjectGuard from 'js/components/pipelines/PipelinesByProjectGuard';
import RecordLineageContainer from 'js/components/recordLineage/RecordLineageContainer';
import { reusableTransformsDashboardScreenConfig } from 'js/components/reusableTransforms/ReusableTransformsDashboard';
import { schemaSpecsDashboardScreenConfig } from 'js/components/schemaSpecs/SchemaSpecsDashboard';
import SendDataFormContainer from 'js/components/sendData/SendDataFormContainer';
import { TeamDetailCollaborate, TeamDetailSettings } from 'new/components/TeamDetail/TeamDetail';
import { AccessInsights } from 'new/components/collaborate/AccessInsights';
import { People360 } from 'new/components/collaborate/People360';
import { ResourceDetail } from 'new/components/collaborate/ResourceDetail';
import { ResourceSharing } from 'new/components/collaborate/ResourceSharing/ResourceSharing';
import { Resources360 } from 'new/components/collaborate/Resources360';
import { UsersShared } from 'new/components/collaborate/UsersShared';
import { Activity } from 'new/components/collaborate/activity';
import { UserDetail } from 'new/components/collaborate/org';
import { OrgDetail } from 'new/components/collaborate/org/OrgDetail';
import { NexsetDetail } from 'new/components/discover/NexsetDetail';
import { Nexsets } from 'new/components/discover/Nexsets';
import { NexsetsAPI } from 'new/components/discover/NexsetsAPI';
import { SQLAutomations } from 'new/components/tasks/SQLAutomations';
import { ByoCreateCanvas } from 'new/components/flows/types/byo/v2-shells/canvas/ByoCreateCanvas';
import { CreateCustomFlow } from 'new/components/flows/types/DirectFlow/CreateDirectFlow';
import CreateDirectFlow from 'new/components/flows/types/DirectFlow/CreateDirectFlow';
import CreateFlow from 'new/components/flows/types/cdc/CreateCDCFlow';
import EditRAGFlow from 'new/components/flows/types/genai_rag/EditRAGFlow';
import CreateReplicationFlow from 'new/components/flows/types/replication/CreateReplicationFlow';
import { EditReplicationFlow } from 'new/components/flows/types/replication/EditReplicationFlow';
import CreateSparkFlow from 'new/components/flows/types/spark/CreateSparkFlow';
import CreateELTFlow from 'new/components/flows/types/elt/CreateELTFlow/CreateFlow';
// import { FlowSelectionPage } from 'new/components/integrate/FlowSelectionPage';
import { AccessRequests } from 'new/components/marketplace/AccessRequests/AccessRequests';
import { DataDomains } from 'new/components/marketplace/DataDomains/DataDomains';
import { DataProducts } from 'new/components/marketplace/DataProducts';
import { EnableMarketplace } from 'new/components/marketplace/EnableMarketplace/EnableMarketplace';
import { ListingRequests } from 'new/components/marketplace/ListingRequests/ListingRequests';
// Monitoring Screens
import { Audit } from 'new/components/monitor/Audit/Audit';
import { DataFlowStatus } from 'new/components/monitor/DataFlowStatus';
import { EditErrorDataSettings } from 'new/components/monitor/EditErrorDataSettings';
import { ErrorData } from 'new/components/monitor/ErrorData';
import { ErrorDataSettings } from 'new/components/monitor/ErrorDataSettings';
import { NotificationSettings } from 'new/components/monitor/NotificationSettings';
import { Notifications } from 'new/components/monitor/Notifications';
import { ResourceTriage } from 'new/components/monitor/ResourceTriage';
import { TriageChatRoute } from 'new/components/monitor/TriageChat';
import { Utilization } from 'new/components/monitor/Utilization';
import { FlowRunsScreen } from 'new/components/monitor/Runs';
import ProjectsList from 'new/components/pipelines/ProjectsList';
import StarredProjectsEmpty from 'new/components/pipelines/StarredProjectsEmpty';
import { Authentication } from 'new/components/settings/Authentication';
import { SdkApplications } from 'new/components/settings/SdkApplications/SdkApplications';
import { DataCustodians } from 'new/components/settings/DataCustodians/DataCustodians';
import { CapsuleDetailScreen, CapsulesSettingsScreen } from 'new/modules/settings/capsules/screens';
import { Impersonation } from 'new/components/settings/Impersonation';
import { CustomerOrgs } from 'new/components/settings/CustomerOrgs';
import { PlanTiers } from 'new/components/settings/PlanTiers';
import { Integrations } from 'new/components/settings/Integrations';
import { Members } from 'new/components/settings/Members';
import { OrganizationInfo } from 'new/components/settings/OrganizationInfo';
import { SecurityNPrivacy } from 'new/components/settings/SecurityNPrivacy';
import { Teams } from 'new/components/settings/Teams';
import { vendorBuilderScreenConfig } from 'new/components/settings/VendorBuilder/VendorBuilder';
import UserPage from 'new/components/settings/userPage/UserPage';
import { RouterManager, ScreenComponent } from 'new/routes/RouterManager';
import EditBaseFlow from 'new/components/flows/types/base/EditBaseFlow';
import FlowNavigationGuard from 'new/components/flows/types/base/FlowNavigationGuard';

const AsyncVendorBuilder = lazyRetry(() =>
  import('new/components/settings/VendorBuilder/VendorBuilder').then((module) => ({
    default: module.VendorBuilder,
  })),
);
const AsyncReusableTransformsDashboard = lazyRetry(
  () => import('js/components/reusableTransforms/ReusableTransformsDashboard'),
);

const AsyncSchemaSpecsDashboard = lazyRetry(
  () => import('js/components/schemaSpecs/SchemaSpecsDashboard'),
);

const manager = new RouterManager(
  RecordLineageContainer,
  UsersShared,
  UserDetail,
  ResourceSharing,
  AccessInsights,
  Resources360,
  People360,
  OrgDetail,
  TeamDetailCollaborate,
  TeamDetailSettings,
  Activity,
  ResourceDetail,
  Utilization,
  ResourceDetail,
  SecurityNPrivacy,
  OrganizationInfo,
  Members,
  Teams,
  DataCustodians,
  CapsuleDetailScreen,
  CapsulesSettingsScreen,
  UserPage,
  {
    screenConfig: {
      ...vendorBuilderScreenConfig,
      component: AsyncVendorBuilder,
    },
  } as unknown as ScreenComponent<unknown>,
  Integrations,
  Authentication,
  SdkApplications,
  Impersonation,
  CustomerOrgs,
  PlanTiers,
  ResourceTriage,
  TriageChatRoute,
  FlowRunsScreen,
  DataFlowStatus,
  Notifications,
  Audit,
  ErrorData,
  ErrorDataSettings,
  NotificationSettings,
  EditErrorDataSettings,
  NexsetDetail,
  Nexsets,
  NexsetsAPI,
  SQLAutomations,
  EditReplicationFlow,
  EditRAGFlow,
  // - - - Create Flows Routes
  CreateFlow,
  CreateReplicationFlow,
  CreateSparkFlow,
  CreateDirectFlow,
  CreateCustomFlow,
  ByoCreateCanvas as unknown as ScreenComponent<unknown>,
  CreateELTFlow as unknown as ScreenComponent<unknown>,
  // - - -
  StarredProjectsEmpty,
  DataProducts,
  EnableMarketplace,
  AccessRequests,
  ListingRequests,
  DataDomains,
  EditBaseFlow,
  ProjectsList as unknown as ScreenComponent<unknown>,
  PipelineFormContainer as unknown as ScreenComponent<unknown>,
  AddDataSourceFormContainer as unknown as ScreenComponent<unknown>,
  ViewDataSourcesContainer as unknown as ScreenComponent<unknown>,
  DestinationSetupContainer as unknown as ScreenComponent<unknown>,
  ViewDataSinksContainer as unknown as ScreenComponent<unknown>,
  SendDataFormContainer as unknown as ScreenComponent<unknown>,
  ViewDataSetsContainer as unknown as ScreenComponent<unknown>,
  {
    screenConfig: {
      ...reusableTransformsDashboardScreenConfig,
      component: AsyncReusableTransformsDashboard,
    },
  } as unknown as ScreenComponent<unknown>,
  {
    screenConfig: {
      ...schemaSpecsDashboardScreenConfig,
      component: AsyncSchemaSpecsDashboard as unknown as ScreenComponent<unknown>,
    },
  } as unknown as ScreenComponent<unknown>,
  DataMapsEditFormContainer as unknown as ScreenComponent<unknown>,
  DataMapDashboardContainer as unknown as ScreenComponent<unknown>,
  CredentialFormContainer as unknown as ScreenComponent<unknown>,
  ViewCredentialsContainer as unknown as ScreenComponent<unknown>,
  ViewAPIKeysContainer as unknown as ScreenComponent<unknown>,
  RecordLineageContainer as unknown as ScreenComponent<unknown>,
  PipelinesContainer as unknown as ScreenComponent<unknown>,
  /**
   * @Guard Routes - Routes with the same structure but different content
   */
  FlowNavigationGuard as unknown as ScreenComponent<unknown>,
  PipelinesByProjectGuard as unknown as ScreenComponent<unknown>,
);

const routesNames = {
  main: manager.getRoutesNames(),
  monitor: manager.getRoutesNames('monitor'),
  integrate: manager.getRoutesNames('integrate'),
  collaborate: manager.getRoutesNames('collaborate'),
  settings: manager.getRoutesNames('settings'),
  marketplace: manager.getRoutesNames('marketplace'),
  tasks: manager.getRoutesNames('tasks'),
};

export const router = {
  routesNames,
  manager,
};
